import { render, staticRenderFns } from "./game-maintai.vue?vue&type=template&id=143b67e6&scoped=true"
import script from "./game-maintai.vue?vue&type=script&lang=js"
export * from "./game-maintai.vue?vue&type=script&lang=js"
import style0 from "./game-maintai.vue?vue&type=style&index=0&id=143b67e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143b67e6",
  null
  
)

export default component.exports